import {VetineoMediaFile} from "./file/vetineo-media-file.model";

/**
 * Reprezentuje pacjenta (zwierzę).
 * Klasa przechowuje kluczowe dane biometryczne, powiązanie z właścicielem oraz statusy (życiowy, reprodukcyjny)
 */
export class Pet {

  /** Obiekt reprezentujący zdjęcie profilowe zwierzęcia. */
  public photo: VetineoMediaFile;

  /** Unikalny identyfikator pacjenta (UUID). */
  public uuid: string;

  public created: Date;
  public modified: Date;
  /** Imię zwierzęcia. */
  public name: string;

  /** Data urodzenia. */
  public birthDate: Date;

  /** Umaszczenie/kolor sierści. */
  public coloration: string;

  /** Flaga usunięcia. */
  public deleted: boolean;

  /** Nazwa gatunku wyświetlana użytkownikowi (np. "Pies", "Kot"). */
  public species: string;

  /** Klucz systemowy gatunku służący do logiki biznesowej. */
  public petSpeciesKey: string;

  /** Rasa zwierzęcia. */
  public breed: string;

  /** Identyfikator właściciela. */
  public ownerId: number;

  /** Status życiowy. */
  public alive: boolean;

  /** Płeć zwierzęcia. */
  public sex: string;

  /** Aktualna waga zwierzęcia (w kg). */
  public weight: number;

  /** Dodatkowy opis, znaki szczególne lub notatki o pacjencie. */
  public description: string;

  /** Status kastracji/sterylizacji (true - zabieg wykonany). */
  public sterilized: boolean;

  constructor() {
  }

}
